/**
 * 这个抽象类用于通过扩展这个类来构建模块
 * 防止将模块导入到根应用模块以外的其他地方
 * 针对只需要导入一次的模块使用
 */
export abstract class EnsureImportedOnceModule {
  protected constructor(targetModule: any) {
    if (targetModule) {
      throw new Error(`${targetModule.constructor.name} 已经被加载.`);
    }
  }
}
